import React from 'react';
import { useTranslation } from 'react-i18next';
import Recommendations from 'components/Common/Recommendations';
import othersAlsoBoughtProducts from 'mockups/othersAlsoBought';

const OthersAlsoBought = () => {
  const { t } = useTranslation();

  // const othersAlsoBought = useSelector((store) => getProductRecommendationByKey(store as Store, ProductRecommendationSlot.OTHERS_ALSO_BOUGHT));
  const othersAlsoBought = {
    products: othersAlsoBoughtProducts,
    slotName: 'slotName',
    rootCategoryId: 1,
  };

  return <Recommendations source={othersAlsoBought} sectionHeader={t('txt_others_also_bought')} />;
};

export default OthersAlsoBought;
